<template>

    <div class="box box-solid">
        <div class="box-header">
            <h2 class="box-title">Budgets</h2>
            <div class="box-tools">
                <div class="btn-group btn-group-sm">
                    <json-excel
                        :data="getJSONData"
                        v-tooltip="'Exporteren naar Excel'"
                        class="btn btn-default"
                    >
                        <i class="mdi mdi-file-excel-box"></i>
                    </json-excel>
                    <button
                        class="btn btn-default"
                        @click="exportToPdf()"
                        v-tooltip="'Exporteren naar PDF'"
                    >
                        <i class="mdi mdi-file-pdf-box"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="box-body no-padding table-responsive">
            <table v-if="loaded" class="table table-striped table-hover" id="budgetsbox">
                <thead>
                    <tr>
                        <th>{{ Lang.get('global.task') }}</th>
                        <th>{{ Lang.get('projects.budgets.headers.completion_percentage') }}</th>
                        <th class="text-right">{{ Lang.get('projects.budgets.headers.total_budget') }}</th>
                        <th class="text-right">{{ Lang.get('projects.budgets.headers.invoiced') }}</th>
                        <th class="text-right">{{ Lang.get('projects.budgets.headers.target_budget') }}</th>
                        <th class="text-right">{{ Lang.get('projects.budgets.headers.used_budget') }}</th>
                        <th class="text-right">{{ Lang.get('projects.budgets.headers.total') }}</th>
                        <th class="text-right">{{ Lang.get('projects.budgets.headers.planned_budget') }}</th>
                        <th class="text-right">{{ Lang.get('projects.budgets.headers.total_planned') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ projectdata.name }}</td>
                        <td class="text-center">
                            <div class="row">
                                <div class="col-sm-11">
                                    <div class="progress progress-xs" style="margin-top:0 !important;">
                                        <div class="progress-bar progress-bar-primary progress-bar-striped" role="progressbar"
                                            :aria-valuenow="projectdata.completion_percentage" aria-valuemin="0" aria-valuemax="100"
                                            :style="'width: ' + projectdata.completion_percentage + '%'">
                                            <span class="sr-only">{{ projectdata.completion_percentage }}%</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-1">
                                    {{ projectdata.completion_percentage }}%
                                </div>
                            </div>
                        </td>
                        <td class="text-right" colspan="7">&nbsp;</td>
                    </tr>

                    <tr
                        v-for="task in projectdata.tasks"
                    >
                        <td>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <router-link
                                :to="{name:'projects.details.tasks', params:{uuid: project.uuid, task_uuid:task.uuid}}"
                            >
                                {{ task.name }}
                            </router-link>
                        </td>
                        <td>
                            <div class="row">
                                <div class="col-sm-11">
                                    <div class="progress progress-xs" style="margin-top:0 !important;">
                                        <div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar"
                                            :aria-valuenow="task.completion" aria-valuemin="0" aria-valuemax="100"
                                            :style="'width:' + task.completion + '%'"
                                        >
                                            <span class="sr-only">{{ task.completion }}%</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-1">
                                    {{ task.completion }}%
                                </div>
                            </div>
                        </td>
                        <td class="text-right">{{ task.total_budget | toCurrency }}</td>
                        <td class="text-right">{{ task.invoiced_total | toCurrency }}</td>
                        <td class="text-right">{{ task.target_budget | toCurrency }}</td>
                        <td class="text-right">{{ task.used_timeregistration_budget | toCurrency }}</td>
                        <td class="text-right">{{ task.budget | toCurrency }}</td>
                        <td class="text-right">{{ task.planned_budget | toCurrency }}</td>
                        <td class="text-right">{{ task.budget - task.planned_budget | toCurrency }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="text-bold">
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td class="text-right">{{ projectdata.total_budget | toCurrency }}</td>
                        <td class="text-right">{{ projectdata.total_invoiced | toCurrency }}</td>
                        <td class="text-right">{{ projectdata.target_budget | toCurrency }}</td>
                        <td class="text-right">{{ projectdata.used_timeregistration_budget | toCurrency }}</td>
                        <td class="text-right">{{ projectdata.total | toCurrency }}</td>
                        <td class="text-right">{{ projectdata.total_planned_budget | toCurrency }}</td>
                        <td class="text-right">{{ projectdata.total - projectdata.total_planned_budget | toCurrency }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div class="overlay" v-if="!loaded">
            <i class="fa fa-refresh fa-spin"></i>
        </div>
    </div>

</template>

<script>

import { mapGetters } from 'vuex';
import Lang from '../../../Lang';
import axios from 'axios';
import jsPDF from "jspdf";
import moment from "moment";
import JsonExcel from 'vue-json-excel';

export default {

    components: {
        JsonExcel,
    },

    computed: {
        ...mapGetters([
            'getProject',
        ]),

        getJSONData() {
            if (!this.loaded) {
                return [];
            }

            return this.projectdata.tasks.map(task => {
                return {
                    project:this.projectdata.name,
                    task:task.name,
                    completion_percentage:task.completion,
                    budget:task.total_budget,
                    invoiced:task.invoiced_total,
                    total_budget:task.target_budget,
                    used_budget:task.used_timeregistration_budget,
                    available_budget:task.budget,
                    planned_budget:task.planned_budget,
                    available_budget_after_planning:task.budget - task.planned_budget
                }
            });
        },

        project() {
            return this.getProject;
        },
    },

    data() {
        return {
            Lang:Lang,
            loaded:false,
            projectdata:{},
        }
    },

    metaInfo: {
        title:'Project budgetten',
    },

    methods: {

        exportToPdf() {
            let doc = new jsPDF({orientation:'landscape'});
            let style = {fontSize:7};
            doc.autoTable({
                html:'#budgetsbox',
                bodyStyles: style,
                footStyles: style,
            });
            doc.save('budgets-' + moment().format('YYYY-MM-DD-HH-mm') + '.pdf');
        },

        getProjectBudgets() {
            axios.get(this.route('api.v1.projects.budget', {project_uuid: this.getProject.uuid}))
                .then(resp => {
                    this.projectdata = resp.data.data;
                    this.loaded = true;
                })
        },
    },

    mounted(){
        this.getProjectBudgets();
    },

    name:'ProjectsDetailsBudgets',

}

</script>
